var _rect, _rect2, _circle, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoImageRound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.1621,
    width: 18.6127,
    height: 18.6127,
    rx: 4.77827,
    transform: "rotate(45 13.1621 0)",
    fill: "#5A3984"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 26.3213,
    y: 13.1602,
    width: 18.6127,
    height: 18.6127,
    rx: 4.77827,
    transform: "rotate(45 26.3213 13.1602)",
    fill: "#FEB005"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.2412,
    cy: 17.0786,
    r: 3.65185,
    transform: "rotate(45 22.2412 17.0786)",
    fill: "#FEB005"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.1602,
    cy: 22.3247,
    r: 3.65185,
    transform: "rotate(45 17.1602 22.3247)",
    fill: "#5A3984"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoImageRound);
export default __webpack_public_path__ + "static/media/logo-image-round.ae210796.svg";
export { ForwardRef as ReactComponent };